  <template>
    <spinner-container :loading="localLoading">
      <back-btn />
      <v-container fluid>
        <v-row justify="center">
          <v-col lg="8">
            <v-card class="card--shadow">
              <ci-edit :ciData="ciEachData" @emitData="updateCi" />
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </spinner-container>
  </template>
  
  <script>
  import { ValidationMixin } from "../../mixins/ValidationMixin";
  import { limitDateMixin } from "../../mixins/limitDateMixin";
  import { mapState } from "vuex";
  import BackBtn from "@/components/navigation/BackBtn.vue";
  import CiEdit from "@/components/ci/CiEdit";

  export default {
    components: { BackBtn,CiEdit },
    mixins: [ValidationMixin, limitDateMixin],
    props: {
      ciData: {
        type: Object,
        default: () => {
          return {
            screening_person: null,
            date: null,
            index_case_year: null,
            index_case_no: null,
            index_case_monopoly: null,
            remark: null,
            symptom:[],
            presumptive_id:null,
            symptom_screening:null,
            screening_township_id:null,
          };
        },
      },
     
    },
    
    data: () => ({
      initialMonopoly: ["No","Yes","SG","MGY","TGI"],
      showList: false,
    }),
    
    
    computed: {
      ...mapState("Loading", ["loading"]),
      ...mapState("Admin", ["admin"]),
      ...mapState("InfoData", ["mdrTbRegs", "typeOfTBOpt"]),
      ...mapState("Township", [ "townships"]),
      ...mapState("Presumptive", ["presumptiveData"]),
      ...mapState("Patient", ["patient"]),
      ...mapState("Ci", ["ciEachData"]),
      

      updatedPresumptiveData() {
      return this.presumptiveData.map(item => {
        // Add a new value to each item
        return {
          ...item,
          ci_date: this.ciData.date,
          screening_person:this.ciData.screening_person,
          screening_township_id:this.ciData.screening_township_id,
          symptom_screening:'2',
        };
      });
    }
      
    },
    methods: {
      updateCi(data) {
      this.$store.dispatch("Ci/update", data).then(() => {
        this.$router.push(
          `/ci-list/${this.$route.params.month}/${this.$route.params.year}/${this.$route.params.township_id}`
        );
      });
    },
    },
    created() {
    this.$store.dispatch("Loading/changeLocalLoading");

    this.$store.dispatch("Ci/getEach", this.$route.params.id).then(() => {
      this.$store.dispatch("Loading/changeLocalLoading");
    });
  },
  };
  </script>
  
  <style scoped></style>
  
  
  